import { userLogin } from '../api/authActions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PersistValuesState {
  isAdult: boolean;
  favoriteNumbers: number[];
  numberOfAutoplayGames: number;
  userToken: string | undefined;
  selectedAutoplayBetAmount: string;
  selectedAutoplayCouponGroup: 'cent' | 'dollar';
}

const initialState: PersistValuesState = {
  isAdult: false,
  favoriteNumbers: [],
  userToken: undefined,
  numberOfAutoplayGames: 1,
  selectedAutoplayBetAmount: '',
  selectedAutoplayCouponGroup: 'cent',
};

export const persistValuesSlice = createSlice({
  name: 'persistValues',

  initialState,

  reducers: {
    setIsAdult: (state) => {
      state.isAdult = true;
    },

    setToken: (state, { payload }) => {
      state.userToken = payload;
    },

    setNumberOfAutoplayGames: (state, { payload }: PayloadAction<number>) => {
      state.numberOfAutoplayGames = payload;
    },

    setSelectedAutoplayBetAmount: (state, { payload }: PayloadAction<string>) => {
      state.selectedAutoplayBetAmount = payload;
    },

    setFavoriteNumbers: (state, { payload }: PayloadAction<number[]>) => {
      state.favoriteNumbers = payload;
    },

    setSelectedAutoplayCouponGroup: (
      state,
      { payload }: PayloadAction<'cent' | 'dollar'>,
    ) => {
      state.selectedAutoplayCouponGroup = payload;
    },

    setDefaultAutoplayValues: (state) => {
      state.favoriteNumbers = [];
      state.numberOfAutoplayGames = 150;
      state.selectedAutoplayBetAmount = '';
      state.selectedAutoplayCouponGroup = 'cent';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userLogin.fulfilled, (state, { payload }) => {
      state.userToken = payload.token;
    });

    builder.addCase(userLogin.rejected, (state) => {
      state.userToken = undefined;
    });
  },
});

export const {
  setToken,
  setIsAdult,
  setFavoriteNumbers,
  setDefaultAutoplayValues,
  setNumberOfAutoplayGames,
  setSelectedAutoplayBetAmount,
  setSelectedAutoplayCouponGroup,
} = persistValuesSlice.actions;

export default persistValuesSlice.reducer;
